import { app } from "@microsoft/teams-js";
import { HotTakeGenre } from "@pollyai/types";
import { Question, QuestionType } from "@teams/types";

import { FetchResult, encodeApiUrl, fetchApiWithContext } from "./ChannelApi";

export type GeneratedHotTakeResponse = Record<HotTakeGenre, Question<QuestionType>[]>;
export type GeneratedIcebreakerResponse = Record<HotTakeGenre, Question<QuestionType>[]>;

export const llmApi = {
  generateHotTakeFromPrompt: async (
    context: app.Context,
    prompt: string
  ): Promise<FetchResult<GeneratedHotTakeResponse>> => {
    return fetchApiWithContext<GeneratedHotTakeResponse>(
      context,
      encodeApiUrl`/v1/llm/hot-take/generate`,
      {
        method: "POST",
        body: JSON.stringify({ prompt }),
      }
    );
  },

  generateIcebreakerFromPrompt: async (
    context: app.Context,
    prompt: string
  ): Promise<FetchResult<GeneratedIcebreakerResponse>> => {
    return fetchApiWithContext<GeneratedIcebreakerResponse>(
      context,
      encodeApiUrl`/v1/llm/icebreaker/generate`,
      {
        method: "POST",
        body: JSON.stringify({ prompt }),
      }
    );
  },
};
